import { render, staticRenderFns } from "./BackArrow.vue?vue&type=template&id=1df9ef02&scoped=true"
import script from "./BackArrow.vue?vue&type=script&lang=js"
export * from "./BackArrow.vue?vue&type=script&lang=js"
import style0 from "./BackArrow.vue?vue&type=style&index=0&id=1df9ef02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df9ef02",
  null
  
)

export default component.exports